export class WorkRandomOffset {
    private readonly edgeClamp = 5;
    private maxOffset = 0;

    constructor(selector: string = ".work-item") {
        const items = document.querySelectorAll<HTMLElement>(selector);
        if (!items.length) return;

        this.calculateMaxOffset(items[0]);
        this.applyRandomOffsets(items);

        console.log(this.maxOffset);
    }

    private calculateMaxOffset(item: HTMLElement): void {
        const parent = item.parentElement;
        if (!parent) return;

        const parentWidth = parent.getBoundingClientRect().width;
        const itemWidth = item.getBoundingClientRect().width;

        const remainingSpacePx = parentWidth - itemWidth;
        const remainingSpacePercent = (remainingSpacePx / parentWidth) * 100;

        this.maxOffset = Math.max(
            0,
            Math.min(100, Number(remainingSpacePercent.toFixed(3)))
        );
    }

    private applyRandomOffsets(items: NodeListOf<HTMLElement>): void {
        items.forEach((item) => {
            item.style.marginLeft = this.randomOffset();
            item.style.marginRight = "0";
        });
    }

    private randomOffset(): string {
        if (this.maxOffset <= this.edgeClamp * 2) {
            return "0%";
        }

        const raw = Math.random() * this.maxOffset;

        if (raw <= this.edgeClamp) {
            return "0%";
        }

        if (raw >= this.maxOffset - this.edgeClamp) {
            return `auto`;
        }

        return `${raw.toFixed(2)}%`;
    }
}
